import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {clearNotifications, removeNotification} from '../store/appActions';

/**
 * Map the properties.
 * @param {*} dispatch
 * @return {Function} the add user function.
 */
function mapDispatchToProps(dispatch) {
  return {
    removeNotification: (notication) =>
      dispatch(removeNotification(notication)),
    clearNotifications: (notication) => dispatch(clearNotifications(notication))
  };
}

/**
 * The notification component.
 * @param {*} props - properties with notification list.
 * @return {String} the compnent conents.
 */
class ConnectedNotifications extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  /**
   * Renders NotariesApp component
   *
   * @return {string} - notary application component to be rendered
   */
  render() {
    return (
      <React.Fragment>
        <div>
          {this.props.notifications.map((notification, i) => {
            // todo figure out correct margin value
            return (
              <Snackbar
                key={i}
                open={true}
                autoHideDuration={notification.autoHideDuration}
                onClose={() => {
                  this.props.removeNotification(notification);
                }}
              >
                <div style={{marginBottom: i * 55}}>
                  <Alert
                    severity={notification.severity}
                    action={
                      <IconButton
                        aria-label='close'
                        color='inherit'
                        size='small'
                        onClick={() => {
                          this.props.removeNotification(notification);
                        }}
                      >
                        <CloseIcon fontSize='inherit' />
                      </IconButton>
                    }
                  >
                    {notification.message}
                  </Alert>
                </div>
              </Snackbar>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

ConnectedNotifications.propTypes = {
  notifications: PropTypes.array.isRequired,
  removeNotification: PropTypes.func.isRequired,
  clearNotifications: PropTypes.func.isRequired
};

const Notifications = connect(null, mapDispatchToProps)(ConnectedNotifications);
export default Notifications;
